var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFF1F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1301 38.19L27.5001 34.36C29.0701 33.78 30.5401 33 31.9001 32.09L29.1301 38.19ZM21.6401 28.5L17.8101 26.87L23.9101 24.1C23.0001 25.46 22.2201 26.93 21.6401 28.5ZM37.6101 18.39C37.6101 18.39 32.6601 16.269 27.0001 21.93C24.8101 24.12 23.5001 26.53 22.6501 28.64C22.3701 29.39 22.5601 30.21 23.1101 30.77L25.2401 32.89C25.7901 33.45 26.6101 33.63 27.3601 33.35C29.8786 32.3897 32.1654 30.9072 34.0701 29C39.7301 23.34 37.6101 18.39 37.6101 18.39ZM30.5401 25.46C29.7601 24.68 29.7601 23.41 30.5401 22.63C31.3201 21.85 32.5901 21.85 33.3701 22.63C34.1401 23.41 34.1501 24.68 33.3701 25.46C32.5901 26.24 31.3201 26.24 30.5401 25.46ZM23.2402 37L25.8801 34.36C25.5401 34.27 25.2101 34.12 24.9101 33.91L21.8302 37H23.2402ZM19.0002 37H20.4102L24.1801 33.24L22.7601 31.83L19.0002 35.59V37ZM19.0002 34.17L22.0901 31.09C21.8801 30.79 21.7301 30.47 21.6401 30.12L19.0002 32.76V34.17Z",
    fill: "#FE544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.6b294040100ecb856ca01734447019ae.svg";
export { ForwardRef as ReactComponent };